module.exports = __webpack_public_path__ + "static/media/cf.f2bacfc2.jpg";